<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.moveDevice')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>               
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card :body-style="{ padding: '0px' }" shadow="never">
                        <div slot="header">
                            <span class="formTitle">{{$t('GroupManage.removeDevice')}}</span>
                        </div>
                        <div class="filter">
                            <el-select v-model="company" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectCompany')" @change="((key)=>{changeCompany(key)})">
                                <el-option v-for="item in companySelect" :key="item.sssid" :label="item.nickname" :value="item.sssid"></el-option>
                            </el-select>  

                            <el-select v-model="group" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectGroup')" :disabled="groupDisable" @change="((key)=>{changeGroup(key)})">
                                <el-option v-for="item in groupSelect" :key="item.sssid" :label="item.trackergroupname" :value="item.sssid"></el-option>
                            </el-select>               
                        </div>
                        <el-table 
                        @selection-change="handleLeftSelection"
                        :data="removeData" 
                        border stripe height="400">
                            <el-table-column width="40px" type="selection" align="center"></el-table-column>
                            <el-table-column prop="imei" :label="$t('DeviceManage.imei')"></el-table-column>

                            <el-table-column prop="trackername" :label="$t('DeviceManage.deviceName')"></el-table-column>

                            <el-table-column prop="modelname" :label="$t('DeviceManage.mode')"></el-table-column>
                        </el-table> 
                        <div class="buttonCenter" style="margin-bottom: 20px">
                            <el-button type="primary" @click="onRemove()">{{$t('Button.removeButton')}}</el-button>
                        </div>                                                 
                    </el-card>            
                </el-col>

                <el-col :span="12">
                    <el-card :body-style="{ padding: '0px' }" shadow="never">
                        <div slot="header">
                            <span class="formTitle">{{$t('GroupManage.addDevice')}}</span>
                        </div>

                        <div class="filter">
                            <el-input v-model="query.input" class="inputWidth mr10 mb10" :placeholder="$t('Query.queryMoveDeviceHolder')"></el-input>
                            <el-select v-model="companySearch" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectCompany')" @change="((key)=>{changeCompanySearch(key)})">
                                <el-option v-for="item in companySelect" :key="item.sssid" :label="item.nickname" :value="item.sssid"></el-option>
                            </el-select>  

                            <el-select v-model="groupSearch" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectGroup')" :disabled="groupSearchDisable" @change="((key)=>{changeGroupSearch(key)})">
                                <el-option v-for="item in groupSearchSelect" :key="item.sssid" :label="item.trackergroupname" :value="item.sssid"></el-option>
                            </el-select>                                           
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{$t('Query.queryBtn')}}</el-button>                               
                        </div>                             

                        <el-table 
                        @selection-change="handlerightSelect"
                        :data="addData" 
                        border stripe height="400" v-loading="loading">
                            <el-table-column width="40px" type="selection" align="center"></el-table-column>
                            <el-table-column prop="imei" :label="$t('DeviceManage.imei')"></el-table-column>

                            <el-table-column prop="trackername" :label="$t('DeviceManage.deviceName')"></el-table-column>

                            <el-table-column prop="modelname" :label="$t('DeviceManage.mode')"></el-table-column>                  
                        </el-table>
                        <div class="filter">
                            <el-select v-model="targetCompany" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectTargetCompany')" @change="((key)=>{changeTgtCompany(key)})">
                                <el-option v-for="item in companySelect" :key="item.sssid" :label="item.nickname" :value="item.sssid"></el-option>
                            </el-select>        
                            <el-select ref="targetselect" v-model="targetGroup" class="inputWidth mr10 mb10" :placeholder="$t('GroupManage.selectTargetGroup')" :disabled="tgtGroupDisable">
                                <el-option v-for="item in tgtGroupSelect" :key="item.sssid" :label="item.trackergroupname" :value="item.sssid"></el-option>
                            </el-select>            
                            <el-button type="primary" @click="onAdd()">{{$t('Button.addButton')}}</el-button>
                        </div>                                                   
                    </el-card>
                </el-col>
            </el-row>             
        </div>
    </div>
</template>

<script>
import api from '../../../api/api.js';

export default {
    data() {
        return {
            company: "",
            group: "",
            companySelect: [],
            groupSelect: [],
            groupDisable: true,
            leftSelect: [],
            rightSelect: [],
            removeData: [],
            addData: [],
            targetCompany: "",
            targetGroup: "",
            tgtGroupSelect: [],
            tgtGroupDisable: true,
            query: {
                input: ""
            },
            loading: false,
            companySearch: "",
            groupSearch: "",
            groupSearchSelect: [],
            groupSearchDisable: true
        };
    },
    created() {
        this.getCompany();
        this.getData();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },        
        getData() {
            this.loading = true;
            let params = {
                key: this.query.input,
                usersssid: localStorage.getItem('sssid'),
                groupsssid: this.groupSearch,
            }
         
            api.getTracker(params)
            .then(res => {
                this.loading = false;
                if(res.state){
                    this.addData = res.value;

                } else {
                    this.$message.error(res.value.text);
                }
            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });  
        },

        getCompany() {
            let params = {
                usersssid: localStorage.getItem('sssid')
            };
            api.getUser(params)
            .then(res => {
                if(res.state){
                    this.companySelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });             
        },
        getGroup(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
            .then(res => {
                if(res.state){
                    this.groupSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });              

        },      
           
        getTargetGroup(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
            .then(res => {
                if(res.state){
                    this.tgtGroupSelect = res.value;          
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });              

        },         
        
        changeCompany(key) {
            this.groupDisable = false;
            this.group = "";
            this.groupSelect = [];
            this.getGroup(key);
        },   

        changeTgtCompany(key) {
            this.tgtGroupDisable = false;
            this.targetGroup = "";
            this.tgtGroupSelect = [];
            this.getTargetGroup(key);
        },

        changeGroup(key) {
            let params = {
                key: "",
                usersssid: localStorage.getItem('sssid'),
                groupsssid: key
            }          
            api.getTracker(params)
            .then(res => {
                if(res.state){
                    this.removeData = res.value;
                } else {
                    this.$message.error(res.value.text);
                }
            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });                
        },

        changeCompanySearch(key) {
            this.groupSearchDisable = false;
            this.groupSearch = "";
            this.groupSearchSelect = [];
            this.getGroupSearch(key);
        },   

        getGroupSearch(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
            .then(res => {
                if(res.state){
                    this.groupSearchSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });              

        },   

        changeGroupSearch(key) {
            // let params = {
            //     key: this.query.input,
            //     usersssid: localStorage.getItem('sssid'),
            //     groupsssid: key
            // }          
            // api.getTracker(params)
            // .then(res => {
            //     if(res.state){
            //         this.addData = res.value;
            //     } else {
            //         this.$message.error(res.value.text);
            //     }
            // })
            // .catch((error) => {
            //     this.$message.error(this.$t('Message.reqError'));
            // });                
        },

		handleLeftSelection(val) {
			this.leftSelect = val;
		},

		handlerightSelect(val) {
			this.rightSelect = val;
		},         

        onRemove() {        
            if(this.leftSelect.length < 1){
                this.$message.warning(this.$t('Message.selectItem'));
                return;
            }  
            // 二次确认删除
            this.$confirm(this.$t('Message.confirmRemove'), this.$t('Message.tip'), {
                type: 'warning'
            })
            .then(() => {                
                let successcount = 0;
                let failinfo = "";
                this.leftSelect.forEach(item => {
                    let removeParam = {
                        groupsssid: this.group,
                        trackersssid: item.sssid
                    };                
                    api.removeTrackerInGroup(removeParam)
                    .then(res => {
                        if(res.state){
                            successcount++;
                        } else {
                            if(failinfo == "") {
                                failinfo += item.trackername;
                            } else {
                                failinfo += "," + item.trackername;
                            }
                        }
                    })
                    .catch((error) => {
                        if(failinfo == "") {
                            failinfo += item.trackername;
                        } else {
                            failinfo += "," + item.trackername;
                        }
                    });                  
                });

                    
                setTimeout(() => {
                    if(failinfo == ""){
                        this.$message.success(this.$t('Message.operate'));
                        this.company = "";
                        this.group = "";
                        this.groupDisable = true;
                        this.leftSelect = [];
                        this.removeData = [];
                    } else {
                        this.$message.error(failinfo + this.$t('Message.operateFail'));
                    }
                }, 1000);   
            })
            .catch(() => {});
        },

        onAdd() {
            if(this.rightSelect.length < 1){
                this.$message.warning(this.$t('Message.selectItem'));
                return;
            }  
            if(this.targetGroup == "") {
                this.$message.warning(this.$t('GroupManage.selectTargetGroup'));
                return;
            }            
            // 二次确认删除
            this.$confirm(this.$t('Message.confirmAddGroup') + this.$refs.targetselect.selected.label + "?", this.$t('Message.tip'), {
                type: 'warning'
            })
            .then(() => {                 
                let successcount = 0;
                let failinfo = "";
                let failMess = "";
                this.rightSelect.forEach(item => {
                    let addParam = {
                        groupsssid: this.targetGroup,
                        trackersssid: item.sssid
                    };                
                    api.AddTrackerInGroup(addParam)
                    .then(res => {
                        if(res.state){
                            successcount++;
                        } else {
                            if(failinfo == "") {
                                failinfo += item.trackername;
                            } else {
                                failinfo += "," + item.trackername;
                            }
                            failMess = res.value.text;
                        }
                    })
                    .catch((error) => {
                        if(failinfo == "") {
                            failinfo += item.trackername;
                        } else {
                            failinfo += "," + item.trackername;
                        }
                    });                  
                });

                    
                setTimeout(() => {
                    this.rightSelect = [];
                    this.getData();
                    if(failinfo == ""){
                        this.$message.success(this.$t('Message.operate'));
                    } else {
                        this.$message.error(failinfo + failMess);
                    }
                }, 1000);  
            })
            .catch(() => {});            
        },

        handleSearch() {
            this.getData();
        }
    }

};
</script>

<style>
.mrtop {
    margin-top: 5px;
}

.mrbottom {
    margin-left: 20px;
    margin-bottom: 5px;
}

.center {
    text-align: center;
}

.filter {
    padding: 20px;
}
</style>